export const WIND_TARGET_FPS = 30;
export const WIND_TARGET_FRAME_INTERVAL_MS = 1000 / WIND_TARGET_FPS;
